import React from 'react';

function ProfilePage() {
    return <h1>Profile</h1>;
}

export default ProfilePage;